import { Injectable } from '@angular/core';
import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import {
  Data,
} from '@orderna/admin-panel/src/utils/service';
import { BehaviorSubject, Observable } from 'rxjs';
import { USER_PROFILES } from '../../data/user-profiles';
import { IUser } from '../../model/user';
import {
  IUserProfile,
  UserProfile,
  UserProfileUpdatePasswordData,
} from '../../model/user-profile';
import { IUserProfilesApiService } from './user-profiles-api.interface';
import { FindProfileResponseDto } from './dtos/find-profile.response.dto';
import { UpdateProfileRequestDto } from './dtos/update-profile.request.dto';
import { UpdateProfileResponseDto } from './dtos/update-profile.response.dto';

@Injectable({
  providedIn: 'root',
})
export class UserProfilesMockApiService implements IUserProfilesApiService {
  data = {
    user_profiles: {
      items: [...USER_PROFILES],
      queryOptions: { page: 1, size: 10 } as QueryOptions<IUserProfile>,
      subject: new BehaviorSubject<Maybe<UserProfile[]>>(null),
      totalSubject: new BehaviorSubject<Maybe<number>>(null),
      totalAfterFilterSubject: new BehaviorSubject<Maybe<number>>(null),
    },
  };

  get userProfilesData() {
    return this.data['user_profiles'] as Data<UserProfile, IUserProfile>;
  }

  findProfile(userId: number): Promise<FindProfileResponseDto> {
    throw new Error('Method not implemented.');
  }

  updateProfile(userId: number, dto: UpdateProfileRequestDto): Promise<UpdateProfileResponseDto> {
    throw new Error('Method not implemented.');
  }

  updateUserProfilePassword(
    userId: IUser['id'],
    password: UserProfileUpdatePasswordData
  ): Observable<any> {
    throw new Error('Method not implemented.');
  }
}
